// src/lib/servicePricing.js
//
// Single source of truth for the service-line display prices (GBP), consumed by
// BOTH the checkout UI (src/pages/customer/Checkout.jsx PLANS) and the
// server-side after-care lifecycle emails (server/services/email.js — which
// already imports from src/lib/, see prepChecklistContent). Plain JS so Node
// can import it from the server bundle as well as Vite from the client.
//
// Bundle is parity-priced (£89 cs_annual + £49 vs01_annual = £138) — no
// discount; framed as convenience, per the Dashboard L2 decision.
export const SERVICE_PRICES_GBP = {
  csOneOff: 100,          // 'cs_filing'
  csAnnual: 89,           // 'cs_annual'
  vs01OneOff: 60,         // 'vs01_oneoff'
  // Verified-client rate for a one-off VS01: offered (by admin one-click, see
  // vs01_verified_client_offer email) to clients who already completed identity
  // verification with us — we hold their details, so most of the work is done.
  vs01VerifiedClient: 21,
  vs01Annual: 49,         // 'vs01_annual'
  csVsBundleAnnual: 138,  // 'cs_vs_bundle_annual'
  companyMonitor: 4.99,   // 'company_monitor' — standalone monitoring, £4.99/mo (R15)
  companyMonitorAnnual: 59.88, // 'company_monitor_annual' — same product billed yearly (12 × £4.99)
  verifyFileBundle: 119,  // 'cs_filing_bundle' (Digital verify + CS filing; real £20 saving vs £39+£100)
  // Dormant accounts (AA02) — the one accounts service safe to sell at a fixed
  // price unseen: dormant since incorporation, subscriber shares only, so the
  // filing is a balance sheet and nothing else. A company that traded before
  // becoming dormant needs real accounts with comparatives (£150) and is
  // quoted by staff, not sold from a button.
  dormantAccounts: 100,       // 'dormant_accounts'
  changeOfDetails: 50,    // per change-of-details filing (TM01 / AP01 / CH01 / AD01); £100 combined resignation+appointment

  // --- Company Formation (one-off incorporation service) ---
  // Base formation (£200) is inclusive of the £100 Companies House digital
  // incorporation fee (the CH fee doubled from £50 on 1 Feb 2026). PAYE/VAT sold
  // à-la-carte as fallback add-ons; bundles carry a small discount vs the
  // à-la-carte sum to pull customers up the ladder ("Complete" is the headline
  // pick). Registered Office is NOT a SKU here — it routes out to
  // taxstatsvirtualoffice.com (annual recurring).
  formation: 200,              // 'formation'        — base incorporation
  formationPaye: 50,           // 'formation_paye'   — à-la-carte PAYE add-on
  formationVat: 100,           // 'formation_vat'    — à-la-carte VAT add-on
  bundleEmployer: 240,         // 'bundle_employer'  — Formation + PAYE (save £10)
  bundleVatReady: 285,         // 'bundle_vat_ready' — Formation + VAT (save £15)
  bundleComplete: 325,         // 'bundle_complete'  — Formation + PAYE + VAT (save £25)

  // Formation + Digital ID verification in one checkout. Built from the existing
  // STRIPE_PRICE_FORMATION (£200) + STRIPE_PRICE_DIGITAL (£39) line items and a
  // £14 Stripe coupon → £225 (save £14 vs £239 separately). 'formation_verify_bundle'.
  formationVerifyBundle: 225,

  // Form + Verify + Compliance as a MONTHLY subscription — the new standard
  // formation offer ('formation_verify_subscription', see
  // docs/design/formation-subscription-revamp.md). Its monthly fee, minimum
  // term, payroll headcount and eligibility limits are deliberately NOT here:
  // the TaxStats Platform's public rate card is the price of record for the
  // "new company starter package", and the pages, checkout and emails read it
  // from there (src/lib/rateCard.js + server/services/rateCard.js). A typed
  // copy in this file is exactly the drift that integration removed.
};
